import styled from "styled-components";

export const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
    background: #f0f2f5;
    font-family: 'Roboto', 'Inter', sans-serif;
`;

export const Header = styled.div`
    background: linear-gradient(115.6deg, #0a9e9e 0%, #175d90 59.58%, #733bb9 100%);
    padding: 16px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 2px 8px rgba(0,0,0,0.25);
    position: sticky;
    top: 0;
    z-index: 100;
`;

export const EventName = styled.span`
    font-family: 'Roboto', sans-serif;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.9);
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const CountersRow = styled.div`
    display: flex;
    gap: 12px;
    padding: 14px 20px 0;
    flex-wrap: wrap;
`;

export const CounterCard = styled.div`
    background: #fff;
    border-radius: 10px;
    padding: 10px 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 90px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.10);
    border-top: 3px solid ${({ color }) => color || '#175d90'};

    .count-number {
        font-size: 22px;
        font-weight: 700;
        color: ${({ color }) => color || '#175d90'};
        line-height: 1.2;
    }
    .count-label {
        font-size: 11px;
        color: #777;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        margin-top: 2px;
    }
`;

export const MainContent = styled.div`
    display: grid;
    grid-template-columns: 1fr 340px;
    gap: 16px;
    padding: 14px 20px 16px;
    flex: 1;
    min-height: 0;        /* permite que o grid shrink abaixo do content-size */
    align-items: stretch; /* colunas se estendem verticalmente */

    @media (max-width: 900px) {
        grid-template-columns: 1fr;
        overflow-y: auto;  /* scroll no mobile */
    }
`;

export const Section = styled.div`
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 1px 6px rgba(0,0,0,0.09);
    display: flex;
    flex-direction: column;
    min-height: 0;  /* permite shrink dentro do grid */
    overflow: hidden;
`;

export const SectionHeader = styled.div`
    background: linear-gradient(115.6deg, #0a9e9e 0%, #175d90 59.58%, #733bb9 100%);
    padding: 12px 18px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #fff;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SectionBody = styled.div`
    padding: 16px;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;  /* permite que o flex-child shrink */
    overflow: hidden;
`;

export const SearchBox = styled.div`
    position: relative;
    margin-bottom: 14px;

    input {
        width: 100%;
        padding: 11px 16px 11px 42px;
        border: 2px solid #e0e0e0;
        border-radius: 8px;
        font-size: 15px;
        font-family: inherit;
        outline: none;
        transition: border-color 0.2s;
        box-sizing: border-box;
        background: #fafafa;

        &:focus {
            border-color: #175d90;
            background: #fff;
        }

        &::placeholder {
            color: #aaa;
        }
    }

    .search-icon {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        color: #aaa;
        font-size: 20px;
    }
`;

export const ResultsList = styled.div`
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-height: 0;
    padding-right: 2px; /* evita que scrollbar sobreponha o card */

    &::-webkit-scrollbar {
        width: 5px;
    }
    &::-webkit-scrollbar-thumb {
        background: #c0c0c0;
        border-radius: 4px;
    }
`;

/* Coluna direita (Registro) precisa de scroll próprio quando o conteúdo excede a tela */
export const RightSection = styled(Section)`
    overflow-y: auto;
`;

export const PersonCard = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border-radius: 8px;
    border: 1px solid #ececec;
    background: ${({ credentialed }) => credentialed ? '#f0faf5' : '#fff'};
    transition: box-shadow 0.15s, border-color 0.15s;
    cursor: default;

    &:hover {
        box-shadow: 0 2px 8px rgba(23, 93, 144, 0.13);
        border-color: #b0d0e8;
    }

    .person-info {
        flex: 1;
        min-width: 0;
    }

    .person-name {
        font-weight: 600;
        font-size: 14px;
        color: #1a1a2e;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .person-sub {
        font-size: 12px;
        color: #777;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 1px;
    }

    .person-badge {
        font-size: 10px;
        padding: 2px 8px;
        border-radius: 20px;
        font-weight: 600;
        white-space: nowrap;
        background: ${({ credentialed }) => credentialed ? '#d4edda' : '#fff3cd'};
        color: ${({ credentialed }) => credentialed ? '#1a7a40' : '#856404'};
        border: 1px solid ${({ credentialed }) => credentialed ? '#b2dfcc' : '#ffd76e'};
    }
`;

export const PersonActions = styled.div`
    display: flex;
    gap: 6px;
    flex-shrink: 0;
`;

export const IconBtn = styled.button`
    background: ${({ variant }) => variant === 'primary' ? 'linear-gradient(135deg, #175d90, #0a9e9e)' : '#f5f5f5'};
    color: ${({ variant }) => variant === 'primary' ? '#fff' : '#555'};
    border: none;
    border-radius: 6px;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 16px;
    transition: opacity 0.15s, transform 0.1s;

    &:hover {
        opacity: 0.85;
        transform: scale(1.05);
    }
    &:active {
        transform: scale(0.97);
    }
    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
        transform: none;
    }
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: 40px 20px;
    color: #aaa;
    font-size: 14px;

    .empty-icon {
        font-size: 36px;
        margin-bottom: 10px;
        opacity: 0.5;
    }
`;

export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 14px;

    .full-width {
        grid-column: 1 / -1;
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
        .full-width { grid-column: 1; }
    }
`;

export const FieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;

    label {
        font-size: 12px;
        font-weight: 600;
        color: #555;
        text-transform: uppercase;
        letter-spacing: 0.04em;
    }

    input, select {
        padding: 9px 12px;
        border: 2px solid #e0e0e0;
        border-radius: 7px;
        font-size: 14px;
        font-family: inherit;
        outline: none;
        transition: border-color 0.2s;
        background: #fafafa;
        width: 100%;
        box-sizing: border-box;

        &:focus {
            border-color: #175d90;
            background: #fff;
        }
    }

    select {
        cursor: pointer;
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='%23999'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 10px center;
        padding-right: 32px;
    }
`;

export const PrimaryBtn = styled.button`
    width: 100%;
    padding: 12px;
    background: linear-gradient(135deg, #175d90 0%, #0a9e9e 100%);
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 700;
    font-family: inherit;
    cursor: pointer;
    transition: opacity 0.2s, transform 0.1s;
    margin-top: 6px;
    letter-spacing: 0.03em;

    &:hover {
        opacity: 0.9;
    }
    &:active {
        transform: scale(0.99);
    }
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const SecondaryBtn = styled.button`
    padding: 9px 18px;
    background: #f0f0f0;
    color: #444;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
        background: #e0e0e0;
    }
`;

export const ModalOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1200;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
`;

export const ModalBox = styled.div`
    background: #fff;
    border-radius: 14px;
    width: 100%;
    max-width: ${({ size }) => size === 'lg' ? '560px' : '420px'};
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 8px 40px rgba(0,0,0,0.22);
    animation: modalIn 0.18s ease-out;

    @keyframes modalIn {
        from { opacity: 0; transform: scale(0.96) translateY(10px); }
        to   { opacity: 1; transform: scale(1) translateY(0); }
    }
`;

export const ModalHeader = styled.div`
    background: linear-gradient(115.6deg, #0a9e9e 0%, #175d90 59.58%, #733bb9 100%);
    padding: 16px 20px;
    border-radius: 14px 14px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
`;

export const ModalBody = styled.div`
    padding: 20px;
`;

export const ModalFooter = styled.div`
    padding: 12px 20px 18px;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
`;

export const TagPreviewBox = styled.div`
    position: relative;
    width: ${({ widthMm }) => widthMm}mm;
    height: ${({ heightMm }) => heightMm}mm;
    border: 1px dashed #ccc;
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
    margin: 12px auto 0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
`;

export const LoadingOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(255, 255, 255, 0.7);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;

    .spinner {
        width: 44px;
        height: 44px;
        border: 4px solid #e0e0e0;
        border-top-color: #175d90;
        border-radius: 50%;
        animation: spin 0.7s linear infinite;
    }
    @keyframes spin {
        to { transform: rotate(360deg); }
    }
`;

export const ContainerBox = styled.div`
    display: flex;
    flex-direction: column;
`;

export const Content = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
`;

export const Align = styled.div`
    width: 100%;
    display: inline-flex;
    position: relative;
    align-items: center;
`;

export const LogoName = styled.span`
    font-family: "Roboto";
    font-size: 26px;
    line-height: 30px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    flex-grow: 1;
    color: #fff;
    opacity: 0.6;
`;
